module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_redefine.js
// module id = 422
// module chunks = 88 89